import LOG from '../../logging/Logger'
import {
  MAX_LENGTH_AREA_NAME,
  MAX_LENGTH_PROJECT_DESCRIPTION,
  MAX_LENGTH_PROJECT_NAME,
  MAX_LENGTH_REPEAT,
  MAX_LENGTH_TAG_NAME,
  MAX_LENGTH_TODO_DESCRIPTION,
  MAX_LENGTH_TODO_SUMMARY
} from '../limits'
import { processLargeArrayAsync } from '../UnitOfWork'
import _ from 'lodash'

const truncate = (item, maxLength) => {
  return item ? item.substring(0, maxLength) : item
}

export default class AllowDuplicates {
  constructor(
    data,
    options,
    createArea,
    createProject,
    createRepeat,
    createTag,
    createFullTodo
  ) {
    this.data = data
    this.options = options
    this.createArea = createArea
    this.createArea = this.createArea.bind(this)
    this.importArea = this.importArea.bind(this)
    this.createProject = createProject
    this.createProject = this.createProject.bind(this)
    this.importProject = this.importProject.bind(this)
    this.createRepeat = createRepeat
    this.createRepeat = this.createRepeat.bind(this)
    this.importRepeat = this.importRepeat.bind(this)
    this.createTag = createTag
    this.createTag = this.createTag.bind(this)
    this.importTag = this.importTag.bind(this)
    this.createFullTodo = createFullTodo
    this.createFullTodo = this.createFullTodo.bind(this)
    this.importTodo = this.importTodo.bind(this)

    this.mapOldToNewAreaIds = {}
    this.useNewProjects = false
    this.mapOldToNewProjectIds = {}
    this.mapOldToNewRepeats = {}
    this.mapOldToNewTags = {}

    this.increment =
      100 /
      ((this.options.areas ? this.data.areas.length : 0) +
        (this.options.projects ? this.data.projects.length : 0) +
        (this.options.repeats ? this.data.repeats.length : 0) +
        (this.options.tags ? this.data.tags.length : 0) +
        (this.options.todos ? this.data.todos.length : 0))
  }

  async importArea(area, incrementProgress) {
    const newArea = await this.createArea(
      truncate(area.name, MAX_LENGTH_AREA_NAME),
      area.colour,
      false
    )
    if (newArea) {
      this.mapOldToNewAreaIds[area.id] = newArea.id
    }
    incrementProgress(this.increment)
  }

  async importProject(project, incrementProgress) {
    const newProject = await this.createProject(
      truncate(project.name, MAX_LENGTH_PROJECT_NAME),
      truncate(project.description, MAX_LENGTH_PROJECT_DESCRIPTION),
      this.options.areas ? this.mapOldToNewAreaIds[project.area] : null,
      project.autoPromote,
      project.autoDelete,
      false
    )
    if (newProject) {
      this.mapOldToNewProjectIds[project.id] = newProject.id
    }
    incrementProgress(this.increment)
  }

  async importRepeat(repeat, incrementProgress) {
    const newRepeat = await this.createRepeat(
      truncate(repeat.pattern, MAX_LENGTH_REPEAT),
      {
        ...repeat.todo,
        name: truncate(repeat.todo.name, MAX_LENGTH_TODO_SUMMARY),
        description: truncate(
          repeat.todo.description,
          MAX_LENGTH_TODO_DESCRIPTION
        ),
        area: this.options.areas
          ? this.mapOldToNewAreaIds[repeat.todo.area]
          : null,
        project: this.options.projects
          ? this.mapOldToNewProjectIds[repeat.todo.project]
          : null
      },
      repeat.startDate
    )
    if (newRepeat) {
      this.mapOldToNewRepeats[repeat.id] = newRepeat.id
    }
    incrementProgress(this.increment)
  }

  async importTag(tag, incrementProgress) {
    const newTag = await this.createTag(
      truncate(tag.name, MAX_LENGTH_TAG_NAME),
      false
    )
    if (newTag) {
      this.mapOldToNewTags[tag.id] = newTag.id
    }
    incrementProgress(this.increment)
  }

  importTodo(todo, incrementProgress) {
    try {
      const newTags = []
      if (todo.tags) {
        const tags = todo.tags.split(',')
        tags.forEach(tag => {
          newTags.push(this.mapOldToNewTags[tag])
        })
      }
      this.createFullTodo(
        truncate(todo.name, MAX_LENGTH_TODO_SUMMARY),
        truncate(todo.description, MAX_LENGTH_TODO_DESCRIPTION),
        todo.status,
        newTags && newTags.length ? newTags.toString() : null,
        this.options.areas ? this.mapOldToNewAreaIds[todo.area] : null,
        this.options.projects ? this.mapOldToNewProjectIds[todo.project] : null,
        todo.list,
        todo.start,
        this.options.repeats ? this.mapOldToNewRepeats[todo.repeat] : null,
        true,
        false
      )
      incrementProgress(this.increment)
    } catch (err) {
      LOG.error('Create Todo error:', err)
      LOG.error('todo:', todo)
    }
  }

  import(incrementProgress, importCompleted) {
    processLargeArrayAsync(
      'Import Areas',
      this.options.areas ? this.data.areas : [],
      area => this.importArea(area, incrementProgress),
      () =>
        processLargeArrayAsync(
          'Import Projects',
          this.options.projects ? this.data.projects : [],
          project => this.importProject(project, incrementProgress),
          () =>
            processLargeArrayAsync(
              'Import Repeats',
              this.options.repeats ? this.data.repeats : [],
              repeat => this.importRepeat(repeat, incrementProgress),
              () =>
                processLargeArrayAsync(
                  'Import Tags',
                  this.options.tags ? this.data.tags : [],
                  tag => this.importTag(tag, incrementProgress),
                  () =>
                    processLargeArrayAsync(
                      'Import TODOs',
                      this.options.todos ? _.reverse(this.data.todos) : [],
                      todo => this.importTodo(todo, incrementProgress),
                      importCompleted,
                      true
                    ),
                  true
                ),
              true
            ),
          true
        ),
      true
    )
  }
}
